<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="翻页效果" name="1">
        <div>
          <div class="font14 mb16">常规翻页</div>
          <el-radio-group
            v-model="animateDirection"
            class="mb16"
            v-if="animateType === 'regular' || animateType === 'inertia'"
          >
            <el-radio label="upDown">上下翻页</el-radio>
            <el-radio label="leftRight">左右翻页</el-radio>
          </el-radio-group>
          <div id="text"></div>
          <ul class="animate-lists">
            <li
              v-for="(animate, index) in regularAnimates"
              :key="index"
              @click="changeAnimateStyle(animate)"
              :class="animateType === animate.animateType ? 'active' : ''"
            >
              <div class="animate-img-box" @mouseenter="animatePlay($event, animate)" @mouseleave="animateStop">
                <img :class="[resLoaded?'':'show','animate-img']" :src="animate.imgSrc" />
<!--                <div class="lottie-box"></div>-->
                <canvas class="canvas lottie-box" width="100" height="100"></canvas>
              </div>
              <p>{{ animate.label }}</p>
            </li>
          </ul>
        </div>
        <div>
          <div class="font14 mb16">特殊翻页</div>
          <ul class="animate-lists">
            <li
              v-for="(animate, index) in specialAnimates"
              :key="index"
              @click="changeAnimateStyle(animate)"
              :class="animateType === animate.animateType ? 'active' : ''"
            >
              <div class="animate-img-box" @mouseenter="animatePlay($event, animate)" @mouseleave="animateStop">
                <img :class="[resLoaded?'':'show','animate-img']" :src="animate.imgSrc" />
<!--                <div class="lottie-box"></div>-->
                <canvas class="canvas lottie-box" width="100" height="100"></canvas>
              </div>
              <p>{{ animate.label }}</p>
            </li>
          </ul>
        </div>
        <div class="full-btn" @click="applyToAllPage">应用到全部页面</div>
        <el-checkbox v-model="isAutoPlay">自动翻页</el-checkbox>
        <div v-if="isAutoPlay" class="setting-item card mt16">
          <slider-and-input
            inputWidth="small"
            inputHeight="small"
            :value.sync="autoPlayTime"
            title="翻页延时"
            titlePosition="singleLine"
            :sliderMax="maxTime"
            suffix="秒"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Anim from "../../../assets/images/lottie/4推出左右.json"
import { withMethodsHistoryCombine } from "utils/revork"
import { simpleDeepClone } from "utils"
export default withMethodsHistoryCombine({
  name: "container-animate",
  data() {
    return {
      activeNames: ["1"],
      maxTime: 30,
      defaultOptions: { animationData: Anim, loop: false, autoplay: false },
      defaultAnim: "",
      pagView:"",
      PAG:null,
      lottieAnimate: "",
      regularAnimates: [
        {
          label: "常规",
          type: "normal",
          animateType: "regular",
          animateClass_up: "up",
          animateClass_down: "down",
          animateClass_left: "left",
          animateClass_right: "right",
          prevpage_animateClass_upDown: "", //前一页
          prevpage_animateClass_lright: "",
          nextpage_animateClass_upDown: "", //后一页
          nextpage_animateClass_lright: "",
          imgSrc: require("../../../assets/images/page_animate/regular.png"),
          lottieUpDown: "/sv2/assets/pag/regular_upDown.pag",
          lottieLeftRight: "/sv2/assets/pag/regular_leftRight.pag"
        },
        {
          label: "惯性",
          type: "normal",
          animateType: "inertia",
          animateClass_up: "up",
          animateClass_down: "down",
          animateClass_left: "left",
          animateClass_right: "right",
          prevpage_animateClass_upDown: "cx-animate-inertia-out",
          prevpage_animateClass_lright: "cx-animate-inertia-out",
          nextpage_animateClass_upDown: "cx-animate-inertia-out",
          nextpage_animateClass_lright: "cx-animate-inertia-out",
          imgSrc: require("../../../assets/images/page_animate/inertia.png"),
          lottieUpDown: `${process.env.VUE_APP_STATIC_URL}/sv2/assets/pag/inertia_upDown.pag`,
          lottieLeftRight:`${process.env.VUE_APP_STATIC_URL}/sv2/assets/pag/inertia_leftRight.pag`
        }
      ],
      specialAnimates: [
        {
          label: "翻书",
          type: "special",
          animateType: "flip",
          animateClass_up: "up",
          animateClass_down: "down",
          animateClass_left: "left",
          animateClass_right: "right",
          prevpage_animateClass_upDown: "cx-animate-flip-out", //前一页
          prevpage_animateClass_lright: "cx-animate-flip-out",
          nextpage_animateClass_upDown: "cx-animate-flip-out", //后一页
          nextpage_animateClass_lright: "cx-animate-flip-out",
          imgSrc: require("../../../assets/images/page_animate/flip.png"),
          lottieJson: "/sv2/assets/pag/flip.pag"
        }
      ],
      resLoaded:false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    stageSource() {
      return this.$store.state[this.request_prefix].page.children
    },
    animateDirection: {
      get() {
        return this.containerAnimateSet.direction
      },
      set(val) {
        this.$changeOptionsEV(val, "containerAnimateSet.direction", false)
        this.changeAnimateStyle()
      }
    },
    isAutoPlay: {
      get() {
        return this.containerAnimateSet.isAutoPlay
      },
      set(val) {
        this.$changeOptionsEV(val, "containerAnimateSet.isAutoPlay", false)
      }
    },
    autoPlayTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.containerAnimateSet, "autoPlayTime", "autoPlayTime", 3)
      },
      set(val) {
        this.$changeOptionsEV(val, "containerAnimateSet.autoPlayTime", false)
      }
    },
    animateType: {
      get() {
        return this.containerAnimateSet.animateType
      },
      set(val) {
        this.$changeOptionsEV(val, "containerAnimateSet.animateType", false)
      }
    },
    containerAnimateSet: {
      get() {
        if (!this.getOptions.containerAnimateSet) {
          let containerAnimateSet = {
            direction: "upDown",
            type: "normal",
            animateType: "regular",
            animateClass__pageUp: "up",
            animateClass__pageDown: "down",
            nextAnimateClass: "",
            prevAnimateClass: "",
            isAutoPlay: false,
            autoPlayDelay: 3
          }
          return this.checkAndSetPrimaryVal(
            this.getOptions,
            "containerAnimateSet",
            "containerAnimateSet",
            containerAnimateSet
          )
        }
        return this.getOptions.containerAnimateSet
      },
      set(val) {
        this.$changeOptionsEV(val, "containerAnimateSet", false)
      }
    },
    getOptions: function () {
      if (!this.$getOptions() || this.$getOptions().length === 0) {
        return {}
      } else {
        return this.$getOptions()
      }
    }
  },
  methods: {
    async animatePlay(event, animate) {
      this.resLoaded = false
      // 实例化 PAG
      const { type, lottieJson, lottieUpDown, lottieLeftRight } = animate
      let pageName =  type === "special" ? lottieJson : this.animateDirection === "upDown" ? lottieUpDown : lottieLeftRight
      window.PAG = PAG || await window.libpag.PAGInit();
      // 获取 PAG 素材数据
      const buffer = await fetch(pageName).then((response) => response.arrayBuffer());
      // 加载 PAG 素材为 PAGFile 对象
      const pagFile = await PAG.PAGFile.load(buffer);
      this.resLoaded = true
      // 将画布尺寸设置为 PAGFile的尺寸
      const canvas = event.target.getElementsByClassName("lottie-box")[0];
      canvas.width = pagFile.width();
      canvas.height = pagFile.height();
      // 实例化 PAGView 对象
      this.pagView = await PAG.PAGView.init(pagFile, canvas);
      // 播放 PAGView
      this.pagView.setRepeatCount(1)
      await this.pagView.play();
    },
    animateStop() {
      if(this.pagView){
        this.pagView.stop()
      }
    },
    changeAnimateStyle(style) {
      const containerAnimateSet = simpleDeepClone(this.containerAnimateSet)
      if (!style) {
        const animates = this.regularAnimates.concat(this.specialAnimates)
        for (let i = 0; i < animates.length; i++) {
          if (animates[i].animateType === containerAnimateSet.animateType) {
            style = animates[i]
            break
          }
        }
      } else {
        if (style.animateType === "flip") {
          this.animateDirection = "leftRight"
        }
        containerAnimateSet.animateType = style.animateType
      }
      containerAnimateSet.animateClass__pageUp =
        this.animateDirection === "upDown" ? style.animateClass_up : style.animateClass_left
      containerAnimateSet.animateClass__pageDown =
        this.animateDirection === "upDown" ? style.animateClass_down : style.animateClass_right
      containerAnimateSet.nextAnimateClass =
        this.animateDirection === "upDown" ? style.nextpage_animateClass_upDown : style.nextpage_animateClass_lright
      containerAnimateSet.prevAnimateClass =
        this.animateDirection === "upDown" ? style.prevpage_animateClass_upDown : style.prevpage_animateClass_lright
      this.$changeOptionsEV(containerAnimateSet, "containerAnimateSet", false)
    },
    applyToAllPage() {
      this.stageSource.forEach(stage => {
        this.$changeOptionsEV(this.containerAnimateSet, "containerAnimateSet", false, "", {
          ...this.ids,
          container_id: stage.container_id
        })
      })
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "已成功应用到所有页面"
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.animate-lists {
  display: flex;
  flex-wrap: wrap;
  > li {
    width: 72px;
    margin: 0 16px 16px 0;
    text-align: center;
    color: var(--subTextColor);
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .animate-img-box {
        border: 1px solid var(--themeColor);
      }
    }
    .animate-hover {
      display: none;
    }
    .animate-img-box {
      overflow: hidden;
      &:hover {
        .animate-hover {
          display: inline-block;
        }
        .animate-img {
          display: none;
        }
        .animate-img.show {
          display: inline-block;
        }
      }
    }
  }
  .animate-img-box {
    display: inline-block;
    width: 72px;
    height: 72px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    margin-bottom: 4px;
    box-sizing: border-box;
    .animate-img {
      margin-top: 14px;
      width: 36px;
      height: 43px;
    }
  }
}
.full-btn {
  width: 100%;
  border: 1px solid;
  color: var(--themeColor);
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  margin: 16px auto;
  cursor: pointer;
  .icon {
    display: inline-block;
    margin-right: 2px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
}
</style>
